import { useBunja } from 'bunja/react';
import { useAtom } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { Tooltip } from '@flipster/react/design-system/tooltip';
import InformationCircleIcon from '@flipster/react/icon/generated/InformationCircleIcon';
import { css } from '@flipster/styled-system/css';
import { flex, hstack, stack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';
import Num, { BigNumber } from '@flipster/utils/num';

import { Slider } from '../../shared/slider';
import { copyTradingSettingsBunja } from '../../state';

export const MaxEntrySlippageSection = () => {
  const { maxEntrySlippageAtom } = useBunja(copyTradingSettingsBunja);
  const [maxEntrySlippage, setMaxEntrySlippage] = useAtom(maxEntrySlippageAtom);
  return (
    <div className={stack({ gap: 8, color: 'content.default.level-5' })}>
      <div className={hstack({ gap: 4 })}>
        <p className={css({ textStyle: 'Text/M/Strong' })}>
          <FormattedMessage id='Copy.r251107.Max_entry_slippage' />
        </p>
        <Tooltip.Root placement='right'>
          <Tooltip.Trigger>
            <InformationCircleIcon size={16} color={token('colors.content.default.level-1')} />
          </Tooltip.Trigger>
          <Tooltip.Content bottomSheetTitle={<FormattedMessage id='Copy.r251107.Max_entry_slippage' />}>
            <FormattedMessage id='Copy.r251107.Max_entry_slippage_desc' />
          </Tooltip.Content>
        </Tooltip.Root>
      </div>
      <div className={flex({ align: 'flex-end', gap: 2, color: 'content.default.level-5' })}>
        <p className={css({ textStyle: 'Title/M/Monospace' })}>{maxEntrySlippage.toString()}</p>
        <p className={css({ textStyle: 'Text/L/Monospace/Strong' })}>%</p>
      </div>
      <Slider
        value={BigNumber.max(maxEntrySlippage, Num(0.1)).toNumber()}
        onChange={(value) => setMaxEntrySlippage(Num(value))}
        min={0.1}
        max={3}
        step={0.1}
        marks={[0.1, 0.5, 1, 2, 3]}
        getLabel={(mark) => `${mark}%`}
      />
    </div>
  );
};
